import { render, staticRenderFns } from "./initiateMaintenance.vue?vue&type=template&id=6d36f7d6"
import script from "./initiateMaintenance.vue?vue&type=script&lang=js"
export * from "./initiateMaintenance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports